<ion-modal [isOpen]="isOpen"
[backdropDismiss]="backdropDismiss"
[cssClass]="'app-base-modal ' + ionClass"
(didDismiss)="closeBaseModal()"
>
  <ng-template>
    <div class="base-modal-shadow bg-white m-auto relative"
    [ngClass]=" customStyle ? customStyle : 'w-72 md:w-84'"
    [ngStyle]="{'border-radius': displayHeader ? '6px' : '8px'}"
    >
      <button *ngIf="!displayHeader && displayCloseButton" class="flex justify-center items-center absolute top-[6px] right-[6px] bg-white rounded-full p-[2px]"
      (click)="closeBaseModal()"
      >
        <ion-icon name="close" class="text-2xl leading-7 max-h-[20px] text-primary"></ion-icon>
      </button>

      <div *ngIf="displayHeader" class="p-3 md:p-4 text-white grid grid-cols-[1fr_auto] items-center gap-4 rounded-t-md"
      [ngClass]="heroHeader ? 'perf-modal-hero md:px-5' : 'bg-primary'"
      >
        <span [ngClass]="{ 'font-bold': heroHeader }">{{modalTitle}}</span>
        <button *ngIf="displayCloseButton" (click)="closeBaseModal()" class="flex justify-center items-center bg-transparent p-[2px]">
          <ion-icon name="close" class="text-2xl leading-7 max-h-[20px] text-white"></ion-icon>
        </button>
      </div>

      <ng-content ></ng-content>
    </div>
  </ng-template>
</ion-modal>

<!-- <ion-modal [isOpen]="isvideoPlayerOpen"
backdropDismiss="true"
cssClass="modal-video-player"
(didDismiss)="closeVideoPlayer()"
> -->
